import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isProduction, setLocalStorageItem } from '../../app/common/util';
import { closeModal } from '../modals/modalActions';
import { changeRoute } from '../nav/SideBar/SideBarActions';

const mapState = state => ({
  auth: state.auth
});

const actions = {
  closeModal,
  changeRoute,
}

const LoginHOC = (PassedComponent) => {

  class LoginParent extends Component {
    static propTypes = {
      auth: PropTypes.object.isRequired,
      changeRoute: PropTypes.func.isRequired,
      closeModal: PropTypes.func.isRequired,
    }

    state = {};

    constructor(props) {
      super(props);

      const { history } = props;

      if (
        history &&
        history.location &&
        history.location.pathname &&
        history.location.pathname !== '/accounts/login' &&
        setLocalStorageItem('currentpathname', history.location.pathname)
      ) {
        if (!this.checkIfUserIsLoggedIn()) {
          props.history.push('/accounts/login');
          if (!isProduction()) {
            props.history.push('/accounts/login');
          }
        }
      }
    }

    checkIfUserIsLoggedIn = () => {
      const { auth } = this.props;
      return (auth && auth.isLoggedIn && auth.isLoggedIn.result) || false;
    }

    render() {
      if (!this.checkIfUserIsLoggedIn()) return null;

      return (
        <PassedComponent
          isLoggedIn={this.checkIfUserIsLoggedIn()}
        />
      )
    }

    componentDidMount() {

      const { changeRoute, closeModal, history } = this.props;

      // close any modal if it's open on route change.
      closeModal();

      // changeroute for sidebar
      changeRoute(history.location.pathname.split('/')[2]);
    }
  }

  return connect(mapState, actions)(LoginParent);
};

export default LoginHOC;
